module.exports = __webpack_public_path__ + "img/spIcon.30b76b19.png";